export const INSERTS_TAB = {
  UPLOAD_INSERTS_LABEL: {
    key: 'UPLOAD_INSERTS_LABEL',
    value: 'Upload Insert',
  },
  UPLOADING_INSERTS_LABEL: {
    key: 'UPLOADING_INSERTS_LABEL',
    value: 'Uploading insert',
  },
  UPLOADED_FILE_EXTENSION_ERROR_MESSAGE: {
    key: 'UPLOADED_FILE_EXTENSION_ERROR_MESSAGE',
    value: 'Please upload only files of extension {{value}}',
  },
  ADD_THIS_INSERT_TO_TEMPLATE_LABEL: {
    key: 'ADD_THIS_INSERT_TO_TEMPLATE_LABEL',
    value: 'Add this insert to template',
  },
  INSERTS_LABEL: {
    key: 'INSERTS_LABEL',
    value: 'Inserts',
  },
  CANCEL_LABEL: {
    key: 'CANCEL_LABEL',
    value: 'Cancel',
  },
  YES_LABEL: {
    key: 'YES_LABEL',
    value: 'Yes',
  },
  NO_LABEL: {
    key: 'NO_LABEL',
    value: 'No',
  },
  DELETE_TEMPLATE_INSERT_QUESTION_LABEL: {
    key: 'DELETE_TEMPLATE_INSERT_QUESTION_LABEL',
    value: 'Are you sure you want to delete this insert?',
  },
  DELETE_INSERT_BUSINESS_LOGIC_QUESTION_LABEL: {
    key: 'DELETE_INSERT_BUSINESS_LOGIC_QUESTION_LABEL',
    value: 'Are you sure you want to delete this business logic?',
  },
  DELETE_LABEL: {
    key: 'DELETE_LABEL',
    value: 'Delete',
  },
  DELETING_LABEL: {
    key: 'DELETING_LABEL',
    value: 'Deleting',
  },
  DELETE_INSERT_LABEL: {
    key: 'DELETE_INSERT_LABEL',
    value: 'Delete Insert',
  },
  DELETE_INSERT_QUESTION_LABEL: {
    key: 'DELETE_INSERT_QUESTION_LABEL',
    value: 'Are you sure you wish to delete insert',
  },
  PREVIEW_LABEL: {
    key: 'PREVIEW_LABEL',
    value: 'Preview',
  },
  BUSINESS_LOGIC_LABEL: {
    key: 'BUSINESS_LOGIC_LABEL',
    value: 'Business logic',
  },
  ADD_BUSINESS_LOGIC_LABEL: {
    key: 'ADD_BUSINESS_LOGIC_LABEL',
    value: 'Add business logic',
  },
  EDIT_BUSINESS_LOGIC_LABEL: {
    key: 'EDIT_BUSINESS_LOGIC_LABEL',
    value: 'Edit business logic',
  },
  DELETE_BUSINESS_LOGIC_LABEL: {
    key: 'DELETE_BUSINESS_LOGIC_LABEL',
    value: 'Delete business logic',
  },
  VIEW_BUSINESS_LOGIC_LABEL: {
    key: 'VIEW_BUSINESS_LOGIC_LABEL',
    value: 'View business logic',
  },
  DRAG_TO_REARRANGE_LABEL: {
    key: 'DRAG_TO_REARRANGE_LABEL',
    value: 'Drag to rearrange',
  },
  CLICK_TO_SHOW_BL_LABEL: {
    key: 'CLICK_TO_SHOW_BL_LABEL',
    value: 'Click to show business logic',
  },
  INSERT_UPLOAD_SUCCESS: {
    key: 'INSERT_UPLOAD_SUCCESS',
    value: 'Insert has been uploaded successfully',
  },
  INSERT_UPLOAD_FAILURE: {
    key: 'INSERT_UPLOAD_FAILURE',
    value: 'An error occured while trying to upload insert. Please try again later.',
  },
  INSERT_DELETE_SUCCESS: {
    key: 'INSERT_DELETE_SUCCESS',
    value: 'Insert has been deleted successfully',
  },
  INSERT_DELETE_FAILURE: {
    key: 'INSERT_DELETE_FAILURE',
    value: 'An error occured while trying to delete insert. Please try again later.',
  },
  INSERT_ADD_SUCCESS: {
    key: 'INSERT_ADD_SUCCESS',
    value: 'Insert has been added to the template successfully',
  },
  INSERT_ADD_FAILURE: {
    key: 'INSERT_ADD_FAILURE',
    value: 'An error occured while trying to add insert to the template. Please try again later.',
  },
  INSERT_SWAP_FAILURE: {
    key: 'INSERT_SWAP_FAILURE',
    value: 'An error occured while trying to swap inserts. Please try again later.',
  },
  INSERT_SWAP_NEXT: {
    key: 'INSERT_SWAP_NEXT',
    value: 'Swap with next insert',
  },
  INSERT_SWAP_PREV: {
    key: 'INSERT_SWAP_PREV',
    value: 'Swap with previous insert',
  },
  PAGES_LABEL_PLURAL: {
    key: 'PAGES_LABEL_PLURAL',
    value: '{{ count }} Pages',
  },
  PAGES_LABEL: {
    key: 'PAGES_LABEL',
    value: '{{ count }} Page',
  },
};
